import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import ConfigValuePickerModal from './ConfigValuePickerModal'
import FilterLink from '../../../components/filter/FilterLink'

const ConfigValuePicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation('serviceOrders')
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiTrafficLightLine'}
        label={label || t('filters.semaphore')}
        value={compactString(value, { t: t, tField: 'semaphoreKeys' })}
        onClick={() => setOpen(true)}
      />
      <ConfigValuePickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default ConfigValuePicker
